import axios from 'axios';

import type {
  IUserUpdateTransferUserBody,
  IUserUpdateTransferUserResponse,
} from '@/app-package';

const updateTransferUser = async (body: IUserUpdateTransferUserBody) => {
  const data = await axios.post<IUserUpdateTransferUserResponse>(
    'transfer/user',
    body,
  );

  return data;
};

export default updateTransferUser;
